import { memo, useMemo } from "react";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { UserKeys } from "@sso/constant";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setUserSortColumn } from "@sso/store/slices/user";
import { ExtendedUserList, TableColumn, UserList } from "@sso/types";
import { LayoutTable, TD, TH, TableWrapper } from "@sso/ui/Table";

import { UserTableActions } from "./UserTableActions";

interface UserTableProps {
  userList: UserList[];
  columns: TableColumn<UserKeys>[];
}

export const UserTable = memo(({ userList, columns }: UserTableProps) => {
  const dispatch = useAppDispatch();

  const data: ExtendedUserList[] = useMemo(
    () =>
      userList.map(user => ({
        ...user,
        [UserKeys.ROLE_NAME]: user.roleName,
        [UserKeys.ORGANISATION_NAME]: user.organisation.name || "-",
        [UserKeys.SOFTWARES_NAME]: user.softwares.map(software => software.name).join(", ") || "-",
        lastLoginDate: user.lastLoginDate ? new Date(user.lastLoginDate).toLocaleDateString() : "-",
        createDate: user.createDate ? new Date(user.createDate).toLocaleDateString() : "-",
      })),
    [userList],
  );

  const handleSortAction = (column: string) => {
    dispatch(setUserSortColumn(column));
  };

  return (
    <TableWrapper>
      <LayoutTable>
        <thead>
          <tr>
            {columns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
            <TH textAlign="center">Actions</TH>
          </tr>
        </thead>
        <tbody>
          {data.map(user => (
            <tr key={user.userId}>
              {columns.map(col => (
                <TD key={col.field}>{(user as unknown as Record<string, string>)[col.field]}</TD>
              ))}
              <UserTableActions userId={user.userId} />
            </tr>
          ))}
        </tbody>
      </LayoutTable>
    </TableWrapper>
  );
});
